import { HttpInterceptorFn } from '@angular/common/http';

export const apiContextInterceptor: HttpInterceptorFn = (request, next) => {
  const correlationId = crypto.randomUUID();
  return next(request.clone({ setHeaders: { 'X-Correlation-Id': correlationId } }));
};
